import useGetMerchant from "@/pages/dashboard/profile/hooks/useGetMerchant";
import { Alert, Button, Image, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect } from "react";
import CustomDrawer from "../drawer";
import forbidden from "@/assets/images/warning.svg";
import { VerificationStatus } from "@/models/club";
import { useNavigate } from "react-router-dom";

function CheckVerification() {
  const [preview, { open, close }] = useDisclosure(false);
  const { data } = useGetMerchant();
  const navigate = useNavigate();
  useEffect(() => {
    if (data && data?.status !== VerificationStatus.Value2) {
      open();
    }
  }, [data]);

  return (
    <CustomDrawer
      opened={preview}
      onClose={close}
      close={close}
      position="bottom"
      radius="md"
      custom="verification"
      title="کاربر گرامی"
    >
      <Stack justify="space-between" h={"350px"}>
        <Stack
          styles={{
            root: {
              flexGrow: 1,
            },
          }}
          align="center"
        >
          {data?.status === VerificationStatus.Value0 && (
            <Stack>
              <Alert color="orange">
                <Text size="xs" ta="center">
                  برای استفاده از سرویس ارسال پیامک، ابتدا اطلاعات خود را تکمیل
                  نمایید.{" "}
                </Text>
              </Alert>
              <Text size="xs" px="xs" ta="center">
                کافیست کد ملی و تصویر کارت ملی خود را وارد کنید تا تأیید شما
                توسط کارشناسان ما در اسرع وقت انجام شود.
              </Text>
            </Stack>
          )}
          {data?.status === VerificationStatus.Value1 && (
            <Alert color="orange">
              <Text size="xs" ta="justify">
                درخواست تایید هویت شما در دست بررسی می باشد و تا زمان تایید
                نهایی امکان ارسال پیامک امکان پذیر نمی باشد. لطفا تا تایید
                کارشناسان ما منتظر بمانید.
              </Text>
            </Alert>
          )}

          <Image src={forbidden} w="170" pt="md" />
        </Stack>
        {data?.status === VerificationStatus.Value0 ? (
          <Button onClick={() => navigate("/dashboard/profile/verification")}>
            تکمیل اطلاعات
          </Button>
        ) : (
          <Button onClick={close} size="md">
            ادامه
          </Button>
        )}
      </Stack>
    </CustomDrawer>
  );
}

export default CheckVerification;
